module.exports = __webpack_public_path__ + "img/turbo_on.8b31d888.png";